import NotFoundScreen from './NotFoundScreen.js';

export default NotFoundScreen;
